<template>
  <div id="DmhConfirm">
    <p
      class="brand-text dmh-confirm-text"
      :class="[isWhiteSpacePreWrap ? 'pre-wrap' : 'custom-space']"
      v-if="question.question_type === 'text'"
      v-html="question.sub_text"
    ></p>
    <img src="/img/dmh/map.png" class="img-fluid" v-else />
  </div>
</template>

<script>
export default {
  name: "DmhConfirm",
  props: ["question", "setAnswer"],
  data() {
    return {
      selectedOptionIndex: null,
      isChecked: false,
      checkbox: null
    };
  },
  computed: {
    isWhiteSpacePreWrap() {
      return ['Informed Consent', 'How we can best support you'].includes(this.question.sub_heading)
    }
  },
  mounted() {
    if(!this.question?.sub_text.includes("Ticking this box")) {
      this.setAnswer(true)
    } else {
      this.checkbox = document.getElementById("agreementCheckbox");
      if (this.checkbox) {
        this.checkbox.addEventListener('change', () => {
          this.updateCheckboxState();
        });
        this.checkbox.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            this.checkbox.checked = !this.checkbox.checked;
            this.updateCheckboxState();
          }
        });
      }
    }
  },
  methods: {
    selectOptionIndex(i) {
      this.setAnswer(i);
      this.selectedOptionIndex = i;
    },
    openPrivacyPolicy() {
      const baseUrl = window.location.origin;
      window.open(baseUrl + "/privacy-policy", "_blank").focus();
    },
    updateCheckboxState() {
      this.isChecked = this.checkbox.checked;
      this.setAnswer(this.isChecked ? true : null);
    }
  }
};
</script>
<style lang="less">
#DmhConfirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  #agreementCheckbox {
    cursor: pointer;
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
  .privacy-text {
    font-family: "PlusJakartaSansBold";
  }
  .privacy-link {
    font-family: "PlusJakartaSansBold";
    text-decoration: underline;
  }
  p {
    text-align: left;
    width: 100%;
    font-size: 1.6rem;
  }
  small {
    font-size: 1.5rem;
  }
  img {
    max-width: 600px;
    border-radius: 16px;
    cursor: not-allowed;
  }
  .dmh-confirm-text {
    font-family: "PlusJakartaSansRegular";
    color: #1E1E22;

    h3 {
      padding: 0;
      letter-spacing: 0;
      margin-bottom: 0;
    }
    ul,
    p {
      margin-bottom: 0;
    }
    h3, ul, li, p {
      color: #1E1E22;
    }
    b {
      font-family: "PlusJakartaSansBold";
    }
    section {
      border: none !important;
      padding: 0 !important;
    }
  }
  .pre-wrap {
    white-space: pre-wrap;

    p {
      white-space: pre-wrap;
      margin-bottom: 12px;
    }
  }
  .custom-space {
    ul, ol {
      &:not(:first-child) {
        padding-left: 20px;
        margin-top: 20px;
      }
    }
    h3:not(:first-child) {
      margin-top: 24px;
    }
    li {
      margin-top: 16px;
    }
    p:not(:first-child), section, .phone_numbers {
      margin-top: 20px;
    }
  }
}
</style>
